const GENERIC_API_ERROR = 'Network response was not ok.'

export const specificMobileError = (
  message: string | null | undefined,
  translate: (key: string) => string
): string | null => {
  if (typeof message !== 'string' || message === '' || message === GENERIC_API_ERROR) {
    return null
  }
  return message
    .split(', ')
    .map((key) => {
      const path = `mobile_de_errors.${key}`
      const translated = translate(path)
      if (translated === path) {
        return key
      }
      return translated
    })
    .join('. ')
}
